import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/empty';

@Injectable()
export class DesignphotoService {
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'q=0.8;application/json;q=0.9' });
    private Url = 'api/designStockEntry'; 
    private Url1 = 'api/researchDc'; 
    private designData = 'api/designData';
    private comboUrl = 'api/combo';
    private printUrl = 'http://localhost/barcode/api/print'; // URL to web api
    private printUrl1 = 'http://localhost/barcode/api/print1'; 
    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }
    designPhoto(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/getDesignPhotos`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getDesignPhotoList(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.designData}/getDesignPhotoList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    print(partyData: any): Promise<any> {
        const url = `${this.printUrl1}`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    checkSample(partyData: any): Promise<any> {
        const url = `${this.Url}/checkSample`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    print1(partyData: any): Promise<any> {
        const url = `${this.printUrl1}`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

    getDesignStockEntry(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/getDesignStockEntry`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getDesignNoList(partyData: any): Promise<any[]> {
        const url = `${this.comboUrl}/getDesignNoList`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    
    getDesignColorList(partyData: any): Promise<any[]> {
        const url = `${this.comboUrl}/getDesignColorList`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    getDesignColorList1(partyData: any): Promise<any[]> {
        const url = `${this.comboUrl}/getDesignColorList1`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    
    addDesignStock(partyData: any): Promise<any> {
        const url = `${this.Url}/addDesignStock`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    addDesignStockFromResearch(partyData: any): Promise<any> {
        const url = `${this.Url1}/addDesignStockFromResearch`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    addTextileStockFromResearch(partyData: any): Promise<any> {
        const url = `${this.Url1}/addTextileStockFromResearch`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

    inwardTextileWarehouseStock(partyData: any): Promise<any> {
        const url = `${this.Url1}/inwardTextileWarehouseStock`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    researchDcReport(partyData: any): Promise<any> {
        const url = `${this.Url1}/researchDcReport`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    getEditDcList(partyData: any): Promise<any> {
        const url = `${this.Url1}/getEditDcList`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    getResearchDcList(partyData: any): Promise<any> {
        const url = `${this.Url1}/getResearchDcList`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    getAutoResearchDc(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url1}/getAutoResearchDc`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    private handleError(error: any): Promise<any> {
        //console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}


// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/services/designphoto.service.ts